// Ein Symbol je Bedeutung (Lucide, Linie 1,5). Größe 16 in Text/Knöpfen, 20 in der Seitenleiste.
import {
  Blocks, Building2, DoorOpen, Euro, FileSignature, Gauge, House, Inbox, KeyRound, Landmark, AlarmClock, Receipt,
  ScanEye, Search, Settings, ShieldCheck, Table2, Upload, Users, Workflow, Wrench, Camera, FolderInput, Layers, List,
  ListChecks, FlaskConical, Image as Bild, FolderSearch, type LucideIcon,
} from "lucide-react";
import type { SymbolName } from "./katalog";

const SYMBOLE: Record<SymbolName, LucideIcon> = {
  cockpit: House,
  posteingang: Inbox,
  bestand: Building2,
  vermietung: KeyRound,
  finanzen: Euro,
  team: Users,
  werkzeuge: Wrench,
  daten: Table2,
  automatik: Workflow,
  verwaltung: ShieldCheck,
  pruefen: ScanEye,
  beleg: Receipt,
  konto: Landmark,
  frist: AlarmClock,
  vertrag: FileSignature,
  einheit: DoorOpen,
  foto: Camera,
  zaehler: Gauge,
  upload: Upload,
  einstellungen: Settings,
  bausteine: Blocks,
  suche: Search,
  verschieben: FolderInput,
  stapel: Layers,
  liste: List,
  regeln: ListChecks,
  labor: FlaskConical,
  bild: Bild,
  ordner: FolderSearch,
};

export function Symbol({ name, groesse = 16 }: { name: SymbolName; groesse?: number }) {
  const Icon = SYMBOLE[name];
  return <Icon size={groesse} strokeWidth={1.5} aria-hidden="true" />;
}
